import { FC, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'primereact/button';
import { SaveSettlementValidated } from '@/pages/Depo20/services/saveAndAddSettlement';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

import AddContainerModalImportFCL from '../AddContainerModalImportFCL';
import AddContainerModalExportFCL from '../AddContainerModalExportFCL';
import AddContainerByBLModalImportFCL from '../AddContainerByBLModalImportFCL';

import './ToolBar.scss';
import AddContainerByBookingModalExportFCL from '../AddContainerByBookingModalExportFCL';

interface ToolBarProps {
  oidLiquidacion: number;
  isImport: boolean;
  disabled?: boolean;
  bodyOnSave: SaveSettlementValidated;
  validRut: () => Promise<boolean>;
  rut: string;
  onLoadingChange?: (loading: boolean) => void;
  onZeroCostDialogChange?: (isOpen: boolean) => void;
  tipo?: 'Import' | 'Export' | 'VacioImportacion';
}
const ToolBar: FC<ToolBarProps> = ({
  oidLiquidacion,
  isImport,
  disabled = false,
  bodyOnSave,
  validRut,
  rut,
  onLoadingChange,
  onZeroCostDialogChange,
  tipo,
}) => {
  const { t } = useTranslation('importFCL');
  const [addImportModalOpen, setAddImportModalOpen] = useState(false);
  const [addImportByBLModalOpen, setAddImportByBLModalOpen] = useState(false);

  const onAddContainerButtonClick = useCallback(async () => {
    if (disabled) return;
    const isValidRut = await validRut();
    if (!isValidRut) {
      return;
    }
    setAddImportModalOpen(true);
  }, [disabled, validRut]);

  const onAddContainerByBLButtonClick = useCallback(async () => {
    if (disabled) return;
    const isValidRut = await validRut();
    if (!isValidRut) {
      return;
    }
    setAddImportByBLModalOpen(true);
  }, [disabled, validRut]);

  return (
    <>
      <div className="w-full button-group">
        <Button
          label={t('addContainer')}
          className="p-button-link"
          icon={<FontAwesomeIcon icon={faPlus} />}
          onClick={onAddContainerButtonClick}
          disabled={disabled}
        />
        {tipo !== 'VacioImportacion' && (
          <Button
            label={t(isImport ? 'addContainerByBL' : 'addContainerByBLExport')}
            className="p-button-link"
            icon={<FontAwesomeIcon icon={faPlus} />}
            onClick={onAddContainerByBLButtonClick}
            disabled={disabled}
          />
        )}
      </div>
      {(tipo === 'Import' || tipo === 'VacioImportacion') && (
        <>
          {addImportModalOpen && (
            <AddContainerModalImportFCL
              visible={addImportModalOpen}
              setVisibility={setAddImportModalOpen}
              bodyOnSave={bodyOnSave}
              oidLiquidacion={oidLiquidacion}
              rut={rut}
              onLoadingChange={onLoadingChange}
              onZeroCostDialogChange={onZeroCostDialogChange}
              tipo={tipo}
            />
          )}
          {addImportByBLModalOpen && (
            <AddContainerByBLModalImportFCL
              visible={addImportByBLModalOpen}
              setVisibility={setAddImportByBLModalOpen}
              bodyOnSave={bodyOnSave}
              oidLiquidacion={oidLiquidacion}
              validRut={validRut}
              rut={rut}
              onLoadingChange={onLoadingChange}
            />
          )}
        </>
      )}
      {tipo === 'Export' && (
        <>
          {addImportModalOpen && (
            <AddContainerModalExportFCL
              visible={addImportModalOpen}
              setVisibility={setAddImportModalOpen}
              oidLiquidacion={oidLiquidacion}
              bodyOnSave={bodyOnSave}
              rut={rut}
            />
          )}
          {addImportByBLModalOpen && (
            <AddContainerByBookingModalExportFCL
              visible={addImportByBLModalOpen}
              setVisibility={setAddImportByBLModalOpen}
              oidLiquidacion={oidLiquidacion}
              bodyOnSave={bodyOnSave}
              validRut={validRut}
              rut={rut}
            />
          )}
        </>
      )}
    </>
  );
};

export default ToolBar;
